import firebase from './firebase';

// Subscription-intent analytics.
//
// Fired at the moment a click actually sends the user to payment: after the
// login and existing-subscription checks, immediately before subscribeHandler
// or tvodHandler redirects. Clicks that end at /login are not attempts.
//
// Only video and series content is tracked. The navbar button carries no
// content, so it reports the surface alone.
const TRACKED_TYPES = ['video', 'series', 'episode'];

export function trackSubscriptionAttempt({ surface, isTvod, type, title, episodeName, season }) {
  if (type !== undefined && !TRACKED_TYPES.includes(type)) {
    return;
  }

  // The player serves a series one episode at a time, typed 'episode'; the
  // event reports the series it belongs to.
  const isSeries = type === 'series' || type === 'episode';
  const params = { surface };

  if (type) {
    params.content_type = isSeries ? 'series' : type;
    params.content_title = title;
  }
  if (isSeries) {
    params.episode_name = episodeName;
    params.season = season;
  }

  try {
    firebase
      .analytics()
      .logEvent(isTvod ? 'tvod_subscription_attempt' : 'subscription_attempt', params);
  } catch (error) {
    // Analytics must never block a payment redirect.
    console.error('Error logging subscription attempt', error);
  }
}

// Fired in payment.utils as the browser leaves for the payment domain, which is
// a separate site and so cannot report its own pageview back here. Pairs with
// the subscription_attempt that preceded it: attempt -> page view.
export function trackSubscriptionPageView() {
  try {
    firebase.analytics().logEvent('subscription_page_view');
  } catch (error) {
    console.error('Error logging subscription page view', error);
  }
}

// Outcome of the journey, reported when the payment domain redirects back to
// /payment/confirm/:status. The branching mirrors PaymentConfirmation's own, so
// the event always agrees with the message on screen: 'pending' and 'prebook'
// are not outcomes and report nothing, and any other status is the cancelled
// case the page already shows.
export function trackSubscriptionResult(status) {
  if (!status) {
    return;
  }

  const value = status.toLowerCase();
  let event;

  if (value.includes('success')) {
    event = 'subscription_successed';
  } else if (value.includes('fail')) {
    event = 'subscription_failed';
  } else if (value.includes('pending') || value.includes('prebook')) {
    return;
  } else {
    event = 'subscription_cancelled';
  }

  try {
    firebase.analytics().logEvent(event);
  } catch (error) {
    console.error('Error logging subscription result', error);
  }
}
